import myRouter from './MyRouterResolver'
import Sku from 'src/pages/catalogs/Package'

let router = myRouter()
router.addComponent('package/:canBeInstall/:index', Sku, {
  modules: ['input', 'typography']
})
export default router
